import React, { useMemo, useState } from 'react'

function buildPixeUri(ss58: string, amount?: number, memo?: string) {
  const base = `pixe:${ss58}`
  const params: string[] = []
  if (typeof amount === 'number' && Number.isFinite(amount) && amount > 0) params.push(`amount=${encodeURIComponent(String(amount))}`)
  if (memo && memo.trim()) params.push(`memo=${encodeURIComponent(memo.trim())}`)
  return params.length ? `${base}?${params.join('&')}` : base
}

export default function ReceiveModal({ open, onClose, address }: { open: boolean; onClose: () => void; address?: string }) {
  const [reqAmount, setReqAmount] = useState('')
  const [reqMemo, setReqMemo] = useState('')
  const hasAddress = Boolean(address && address.length >= 8)
  const short = hasAddress ? `${address!.slice(0, 12)}...${address!.slice(-6)}` : '--'
  const amountNum = useMemo(() => {
    const n = Number((reqAmount || '').replace(/,/g, '.'))
    return Number.isFinite(n) && n > 0 ? n : undefined
  }, [reqAmount])
  const paymentUri = useMemo(() => (hasAddress ? buildPixeUri(address!, amountNum, reqMemo) : ''), [hasAddress, address, amountNum, reqMemo])

  async function copy(value?: string) {
    try {
      await navigator.clipboard.writeText(value || '')
    } catch {}
  }

  if (!open) return null
  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="absolute inset-x-0 bottom-0 md:inset-0 md:flex md:items-center md:justify-center">
        <div className="md:w-[560px] w-full bg-neutral-950 border-t md:border border-white/10 rounded-t-2xl md:rounded-2xl p-4">
          <div className="w-10 h-1 rounded bg-white/20 mx-auto mb-2 md:hidden" />
          <div className="text-white font-extrabold text-lg mb-1">Receive PIXE</div>
          <div className="text-white/70 text-sm mb-3">Share your PixeChain address or a payment link so others can send you PIXE.</div>

          <div className="rounded-xl border border-white/10 bg-white/5 p-3 mb-3">
            <div className="text-white/70 text-xs mb-1">Your address</div>
            <div className="text-white font-mono break-all">{address || '—'}</div>
            <div className="mt-2 flex gap-2">
              <button onClick={() => copy(address)} disabled={!hasAddress} className="px-3 py-1.5 rounded-lg border border-white/15 text-white/90 hover:bg-white/10 disabled:opacity-60">Copy SS58</button>
              <button onClick={() => copy(paymentUri || address)} disabled={!hasAddress} className="px-3 py-1.5 rounded-lg border border-white/15 text-white/90 hover:bg-white/10 disabled:opacity-60">Copy Payment Link</button>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 mb-3">
            <label className="block">
              <div className="text-white/70 text-sm mb-1">Request Amount (PIXE)</div>
              <input value={reqAmount} onChange={(e)=>setReqAmount(e.target.value)} placeholder="0.00" className="w-full rounded-lg bg-white/5 border border-white/10 px-3 py-2 outline-none" />
            </label>
            <label className="block">
              <div className="text-white/70 text-sm mb-1">Memo (optional)</div>
              <input value={reqMemo} onChange={(e)=>setReqMemo(e.target.value)} placeholder="For coffee ☕" className="w-full rounded-lg bg-white/5 border border-white/10 px-3 py-2 outline-none" />
            </label>
          </div>

          <div className="flex justify-end">
            <button onClick={onClose} className="px-4 py-2 rounded-lg border border-white/15 text-white/90 hover:bg-white/10">Done</button>
          </div>

          <div className="text-white/50 text-xs mt-2">This is your PixeChain receive address (SS58). Never share your seed phrase.</div>
        </div>
      </div>
    </div>
  )
}
